import { render } from "./MessageTemplateForm.vue?vue&type=template&id=f82b7f42"
import script from "./MessageTemplateForm.vue?vue&type=script&lang=js"
export * from "./MessageTemplateForm.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__